import React, { useContext } from "react";
import CardApplicationAPI from "../../api/commercial/card-application";
import { ApplicationFlows } from "../../route/application/authenticated/application-flow/types";
import { ApplicationFlowSteps } from "../../route/application/authenticated/application-flow/types";
import { ErrorContext } from "../../route/error/provider";
import CardholderBasicMapper from "../cardholder-basic-information/mapper";
import CardholderAdditionalBenefits from "./index";
import CardholderBenefitsMapper from "./mapper";
import { CardholderBenefitsModel } from "./types";
import { LanguageContext } from "../../context/languageContext";
import { CardApplicationDocument } from "../../api/commercial/generated-types";

export default function CardholderAdditionalBenefitsAdapter({
  flowType,
  cardApplication,
  triggerReload,
  setStep,
}: {
  flowType: ApplicationFlows;
  cardApplication: CardApplicationDocument;
  triggerReload: () => void;
  setStep: (step: ApplicationFlowSteps) => void;
}): React.JSX.Element {
  const cardholderApplicationRef = cardApplication.applicationRef;
  const basicAccountApplicationRef = cardApplication.basicAccountApplicationRef;
  const companyName = cardApplication.company.name;

  const cardholderBenefitsModel: CardholderBenefitsModel =
    CardholderBenefitsMapper.mapDocumentToPageModel(cardApplication);

  const { language } = useContext(LanguageContext);
  const cardholder = CardholderBasicMapper.mapCardholderDocumentToPageModel(
    cardApplication,
    language,
  );

  const { setError } = useContext(ErrorContext);
  return (
    <CardholderAdditionalBenefits
      flowType={flowType}
      initial={cardholderBenefitsModel}
      context={{
        cardholder,
        companyName,
      }}
      previous={() => {
        setStep(ApplicationFlowSteps.CARDHOLDER);
      }}
      next={async (model: CardholderBenefitsModel) => {
        try {
          const request = CardholderBenefitsMapper.mapPageModelToRequest(model);
          await CardApplicationAPI.saveCardholderBenefits(
            request,
            basicAccountApplicationRef,
            cardholderApplicationRef,
          );
        } catch (e) {
          setError(e);
        }
        triggerReload();
      }}
    />
  );
}
